import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { WebServicesService } from '../web-services/web-services.service';
import { UserApplication } from './user-application.model';
import { NotificationService } from '../../service/notification/notification.service';

@Injectable({
	providedIn: 'root'
})
export class UserApplicationService {

	constructor(
		private notificationService: NotificationService,
		private translateService: TranslateService,
		private webServicesService: WebServicesService
	) { }

	/* Appels aux webServices */

	public getUserApplication(userId: string): Promise<UserApplication[]> {
		console.log('RÃ©cupÃ©ration des userApplication de l\'utilisateur ' + userId);
		return this.webServicesService.getList<UserApplication>('/user_application?userId=' + userId)
			.then(pagedData => {
				if (pagedData && pagedData._embedded)
					return Promise.resolve(pagedData._embedded[Object.keys(pagedData._embedded)[0]]);
				else
					return Promise.resolve([]);
			})
			.catch(error => {
				this.notificationService.showError(this.translateService.instant('GET_USER_APPLICATIONS_ERROR'));
				return Promise.reject(error);
			})
	}

	public putUserApplication(userId: string, applicationId: string, customerTreeId: number, visible: boolean): Promise<UserApplication> {
		console.log('Ajout d\'un nouveau userApplication');
		let json = {
			userId: userId,
			applicationId: applicationId,
			customerTreeId: customerTreeId,
			visible: visible
		}
		return this.webServicesService.put<UserApplication>('/user_application', json)
			.catch(error => {
				this.notificationService.showError(this.translateService.instant('ERROR'));
				return Promise.reject(error);
			})
	}

	public deleteUserApplication(userApplicationId: number): Promise<any> {
		console.log("Suppression du userApplication " + userApplicationId);
		return this.webServicesService.delete('/user_application/' + userApplicationId)
			.catch(error => {
				this.notificationService.showError(this.translateService.instant('ERROR'));
				return Promise.reject(error);
			})
	}
}
